/**
 * Add sleep time
 * @param  {number} ms   Time in millisecond
 */
export default function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
